import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import saasApi from '../../utils/saasApi';

export default function SelfServiceBranches() {
  const [branches, setBranches] = useState([]);
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    saasApi.getBranches().then((rows) => { if (active) setBranches(rows); })
      .catch((err) => { if (active) setError(err.message || 'No se pudieron cargar las sucursales'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const save = async (event) => {
    event.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true); setError('');
    try {
      const result = await saasApi.createBranch({ name: name.trim(), address: address.trim(), city: city.trim() });
      setBranches((current) => [...current, { id: result.id, name: name.trim(), city: city.trim() }]);
      setName(''); setAddress(''); setCity('');
    } catch (err) { setError(err.message || 'No se pudo crear la sucursal'); }
    finally { setSaving(false); }
  };

  return <Box component="section" sx={{ maxWidth: 780 }}>
    <Typography variant="h6" gutterBottom>Sucursales de tu empresa</Typography>
    <Typography color="text.secondary" mb={2}>La empresa se creó con tu cuenta. Registrá al menos una sucursal antes de agregar cámaras.</Typography>
    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    {loading ? <CircularProgress aria-label="Cargando sucursales" /> : branches.length
      ? <Stack spacing={1} mb={3}>{branches.map((branch) => <Typography key={branch.id}>{branch.name}{branch.city ? ` · ${branch.city}` : ''}</Typography>)}</Stack>
      : <Alert severity="info" sx={{ mb: 2 }}>Todavía no hay sucursales registradas.</Alert>}
    <Stack component="form" onSubmit={save} spacing={2}>
      <TextField required label="Nombre de la sucursal" value={name} onChange={(event) => setName(event.target.value)} inputProps={{ maxLength: 120 }} />
      <TextField label="Dirección" value={address} onChange={(event) => setAddress(event.target.value)} />
      <TextField label="Ciudad" value={city} onChange={(event) => setCity(event.target.value)} />
      <Button type="submit" variant="contained" disabled={saving || !name.trim()}>{saving ? 'Guardando…' : 'Crear sucursal'}</Button>
    </Stack>
  </Box>;
}
